import { createNotivue } from 'notivue'

export function registerNotivue(app: any) {
  const notivue = createNotivue({
    position: 'bottom-left',
    limit: 2,
    enqueue: true,
    pauseOnHover: true,
    avoidDuplicates: true,
    notifications: {
      global: {
        duration: 5000
      }
    }
  })

  app.use(notivue)
}
